import React from 'react';
import {connect} from 'react-redux';
import Users from "./Users";
import EmailValidator from "email-validator";
import UsersService from "../UsersService/UsersService";

class UsersContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            isLoading: true,
        };

        const accessToken = props.authService.getAccessToken();

        this.usersService = new UsersService(accessToken);

        this.handleUsers();
    }

    handleUsers() {
        this.usersService.get()
            .then(result => {
                this.setState({
                    users: result.data,
                    isLoading: false,
                })
            })
            .catch();
    }

    create(email) {
        if (EmailValidator.validate(email)) {
            this.usersService.create(email)
                .then(() => {
                    this.setState({isLoading: true});
                    this.handleUsers();
                })
                .catch();
        }
    }

    remove(email) {
        this.usersService.delete(email)
            .then(() => {
                this.setState({isLoading: true});
                this.handleUsers();
            })
            .catch()
    }

    render() {
        return <Users
            users={this.state.users}
            isLoading={this.state.isLoading}
            create={this.create.bind(this)}
            remove={this.remove.bind(this)}
        />;
    }
}

const mapStateToProps = (state) => ({domain: state.domain.domain});

export default connect(mapStateToProps)(UsersContainer);
